/**
 * Builds the children-ages array for lodging availability requests, mapping
 * infants to the hotel convention: lap infants → age 0, seat infants → age 1.
 *
 * @param childAges  Ages of child passengers (typically 2–11 years old).
 * @param infantOnLapCount  Number of lap infants to append as age 0.
 * @param infantInSeatCount  Number of seat infants to append as age 1.
 */
export function buildLodgingChildrenAges(
  childAges: number[],
  infantOnLapCount: number,
  infantInSeatCount: number
): number[] {
  return [
    ...childAges,
    ...Array(infantOnLapCount).fill(0),
    ...Array(infantInSeatCount).fill(1),
  ];
}
